import React, {Component} from "react";
import looker_studio_logo from '../../images/data_node_icon.png';

export class DataNodeLogo extends Component {

    getHspace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVspace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getWidth() {
        return this.props.width || 20;
    }

    getHeight() {
        return this.props.height || 20;
    }

    getImage() {
        return looker_studio_logo;
    }

    render() {
        return <img alt="Nodo de datos" style={this.props.styles} src={this.getImage()} height={this.getHeight()}
                    width={this.getWidth()} hspace={this.getHspace()} vspace={this.getVspace()}
        />
    }
}
